import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT } from "@/lib/data";

const links = [
  { label: "Services", href: "#services" },
  { label: "How We Work", href: "#work" },
  { label: "Apps", href: "#apps" },
  { label: "Pricing", href: "#book" },
  { label: "Contact", href: "#request" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
      className={`fixed top-0 left-0 right-0 z-50 animate-nav-drop transition-colors duration-500 ${
        scrolled ? "bg-[#0a1526]/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-24 lg:h-32 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src="/logo-mark.png?v=4" alt="" className="h-16 lg:h-24 w-auto group-hover:scale-105 transition-transform" />
          <img src="/logo-wordmark.png?v=4" alt="Link-Lite Data LLC" className="h-9 lg:h-14 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-white/60 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-call-btn"
            className="hidden sm:inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm font-medium hover:border-[#3B82F6] hover:text-[#60A5FA] transition-colors"
          >
            <Phone className="h-4 w-4" /> {CONTACT.phone}
          </a>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden p-2 text-white"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a1526]/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-sm uppercase tracking-[0.2em] text-white/70"
            >
              {l.label}
            </a>
          ))}
          <a href={CONTACT.phoneHref} className="text-[#60A5FA] font-medium">{CONTACT.phone}</a>
        </div>
      )}
    </header>
  );
};
